import { getConsent } from '../api';
import { Consent } from './types';

export const handleConsentStatusUpdate = (onUpdate: (consent: Consent) => void) => async (consentId: string) => {
    getConsent(consentId).then(onUpdate);
};
